<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退款对象：</span>
        </div>
        <el-select v-model="refundPayerCodes"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod1"
                   placeholder="请选择退款对象">
          <el-option v-for="item in refundPayerList" :key="item.personCode?item.personCode:item.enterpriseCode"
                     :label="item.payer" :value="item.personCode?item.personCode:item.enterpriseCode">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账单名称：</span>
        </div>
        <el-select v-model="chargeBillCodes"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod2"
                   placeholder="请选择退款账单">
          <el-option v-for="item in chargeBillList" :key="item.code"
                     :label="item.message" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <!-- <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费住户：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" disabled />
      </div> -->
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退款金额：</span>
        </div>
        <el-input v-model="formData.refundAmount" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>


      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
 
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/CustomPayment";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";

export default {
  components: {
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "refund-management-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧收费",
          name: "charge-items-management"
        },
        {
          value: "退款管理"
        }
      ],
      mainTitle: "添加退款",
      subheading: "",
      payChannelModifyList: [
        {
          key: "1",
          label: "微信"
        },
        {
          key: "2",
          label: "支付宝"
        },
        {
          key: "3",
          label: "银行转账"
        },
        {
          key: "4",
          label: "现金"
        },
        {
          key: "5",
          label: "其他"
        }
      ],
      payStatusModifyList: [
        {
          key: "0",
          label: "未缴费"
        },
        {
          key: "2",
          label: "完全支付"
        }
      ],
      invoiceStatusModifyList: [
        {
          key: "0",
          label: "未开票"
        },
        {
          key: "1",
          label: "已开票"
        }
      ],
      formData: {},
      refundPayerCodes: "",
      refundPayerList: [],
      chargeBillCodes: "",
      chargeBillList: []
    };
  },
  created() {
    this.currentCode = this.$route.params.id;
    this.remoteMethod1();
    this.remoteMethod2();
  },
  methods: {
    remoteMethod1(query) {
      this.getChargeBillPayerList(query);
    },
    remoteMethod2(query) {
      this.getChargeBillList(query);
    },
    //获取退款对象列表
    getChargeBillPayerList(searchKey) {
      this.$axios
        .post(api.getChargeBillPayerList, { searchKey: searchKey || "" })
        .then(res => {
          let data = res.data.data;
          var payer = [];
          let refundPayerList = [];
          for (var i = 0; i < data.length; i++) {
            if (payer.indexOf(data[i].payer) == -1) {
              payer.push(data[i].payer);
              refundPayerList.push(data[i]);
            }
          }
          this.refundPayerList = refundPayerList;
        })
        .catch(errorHandler("获取退款对象列表失败"));
    },
    // 获取已付款账单列表
    getChargeBillList(searchKey) {
      this.$axios
        .post(api.getChargeBillList, { searchKey: searchKey || "" })
        .then(res => {
          let data = res.data.data;
          var bill = [];
          this.chargeBillList = [];
          for (var i = 0; i < data.length; i++) {
            if (data[i].payer === this.formData.refundObj) {
              bill.push(data[i].paymentItemName);
              this.chargeBillList.push(data[i]);
            }
          }
          if (this.chargeBillList) {
            this.chargeBillList.map(v => {
              v.message =
                v.paymentItemName + "/" + v.chargeAmount + "元/" + v.payTime;
            });
          }
        })
        .catch(errorHandler("获取退款对象列表失败"));
    },

    toManagement() {
      this.$router.push({
        name: "refund-management"
      });
    },
    getPaymentBillRecordByCode() {
      this.$axios
        .get(`${api.getPaymentBillRecordByCode}/${this.currentCode}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData = res.data.data;
          }
        })
        .catch(errorHandler("查询信息失败"));
    },
    confirm() {
      if (!this.formData.refundObj) {
        nError("请选择退款对象");
        return false;
      }
      if (!this.formData.billCode) {
        nError("请选择指定账单");
        return false;
      }
      if (!this.formData.refundAmount) {
        nError("请输入退款金额");
        return false;
      }
      this.$axios
        .post(api.addRefundBill, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.toManagement();
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.toManagement();
    }
  },
  watch: {
    refundPayerCodes(val) {
      this.refundPayerList.map(v => {
        if (v.personCode === val || v.enterpriseCode === val) {
          this.formData.refundObj = v.payer;
          this.getChargeBillList();
        }
      });
      this.chargeBillCodes = "";
    },
    chargeBillCodes(val) {
      this.chargeBillList.map(v => {
        if (v.code === val) {
          this.formData.billCode = v.code;
          this.formData.billAmount = v.chargeAmount;
          this.getChargeBillList();
        }
      });
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 140px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin: 40px 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/view/CustomPayment/RefundManagement/RefundManagementAdd.vue